import * as yup from 'yup';

const REQUIRED_IMAGE_MESSAGE = 'Por favor, selecione uma imagem.';

export const baseImageFieldSchema = yup.object({
  preview: yup.string().nullable(),
  name: yup.string().nullable(),
  file: yup.mixed().nullable(),
});

export const requiredImageFieldSchema = yup.object({
  preview: yup.string(),
  file: yup.mixed().when('preview', ([preview], schema) => {
    return preview === ''
      ? schema.concat(yup.mixed().required(REQUIRED_IMAGE_MESSAGE))
      : schema;
  }),
});
